<div class="row mb-row">
  <!-- <div class="col-12" *ngIf="!suggeritiFound || suggeritiFound.length === 0">
    <h5>Nessun soggetto suggerito</h5>
  </div> -->
  <div class="col-12 mb-row p-row" *ngIf="altreParti && altreParti.length > 0">
    <p>Soggetti terzi associati: </p>
    <app-step-soggetti-terzi-list-altreparti [associable]="false" [labelComponent]="'altreparti'" [action] = "action" (actionEmitter)="action = $event"></app-step-soggetti-terzi-list-altreparti>
  </div>
  <div class="col-12" *ngIf="suggeritiFound && suggeritiFound.length > 0">
    <h5>Soggetti terzi suggeriti :</h5>
    <app-step-soggetti-terzi-list [associable]="true" [labelComponent]="'suggested'" [action] = "action" (actionEmitter)="action = $event" [soggetti]="suggeritiFound"></app-step-soggetti-terzi-list>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="container_tab_nav">
      <ul class="nav nav-tabs two">
        <li [style.width.%]="50" class="{{activeTab === 0 ? 'active' : 'inactive'}}"><a data-toggle="tab"
            (click)="activeTab = 0" aria-expanded="true">Cerca</a></li>
        <li [style.width.%]="50" class="{{activeTab === 1 ? 'active' : 'inactive'}}"><a data-toggle="tab"
            (click)="activeTab = 1" aria-expanded="false">Inserisci</a></li>
      </ul>
      <div class="tab-content">
        <div *ngIf="activeTab === 0" class="tab-pane fade active in">
          <div searchTextInput #searchElement [url]="requestSearchUrl" (onReturn)="retrieveSearch($event)"></div>
          <div class="col-12" *ngIf="foundElements && foundElements.length > 0">
            <h5>Risultati : </h5>
            <app-step-soggetti-terzi-list [associable]="true" [labelComponent]="'found'" [action]="action"
              (actionEmitter)="action = $event" [soggetti]="foundElements"
              (parteChange)="onEmitSearch($event)"></app-step-soggetti-terzi-list>
          </div>

          <p *ngIf="hasSearched && foundElements.length == 0">Nessuna parte trovata.</p>
        </div>
        <div *ngIf="activeTab === 1" class="tab-pane fade active in">
          <app-step-soggetti-terzi-form [parte]="parte"
            (altraParteChange)="retrieveNewSoggettoTerzo($event)"></app-step-soggetti-terzi-form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block'  (click)="salva()">
      Prosegui
    </button>
  </p>
</div>
